import React from 'react';

import AuditArea from './leftpanel-components/audit-area';
import AnalyzeImagery from './leftpanel-components/analyze-imagery';
import ContextualData from './leftpanel-components/contextual-data';
import MergeIntersect from './leftpanel-components/merge-intersect';
import PerformAudit from './leftpanel-components/perform-audit/perform-audit';

import './leftpanel-active-section.scss';

const ActiveSection = ({ selectedPanel, mapLayersToggled }: { selectedPanel: string; mapLayersToggled: boolean }) => {
  const displaySelectedPanel = () => {
    switch (selectedPanel) {
      case 'select-area':
        return <AuditArea />;
      case 'analyze-imagery':
        return <AnalyzeImagery />;
      case 'contextual-data':
        return <ContextualData />;
      // case 'map-layers':
      //   return <MapLayers />;
      case 'merge-intersect':
        return <MergeIntersect />;
      case 'perform-audit':
        return <PerformAudit />;
      default:
        console.log(`No panel for ${selectedPanel}`);
    }
  };

  return (
    <div
      className={`active-section ${selectedPanel} ${mapLayersToggled ? 'map-layers-open' : 'map-layers-closed'}`}
      style={{
        bottom: `${
          selectedPanel === 'perform-audit' || selectedPanel === 'merge-intersect'
            ? `calc(100% - ${document.getElementById(selectedPanel)!.getBoundingClientRect().bottom}px)`
            : 'unset'
        }`,
      }} // THIS STYLE IS TO HANDLE POSITIONING FOR THE ONLY PANEL THAT OPENS BOTTOM ALIGNED
    >
      {displaySelectedPanel()}
    </div>
  );
};

export default ActiveSection;
